var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Slabs")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Slab List"
    },
    on: {
      "click": _vm.showCreateSlab
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Slab Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slabName),
      expression: "slabName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabName')
    },
    attrs: {
      "type": "text",
      "name": "slabName",
      "id": "slabName",
      "placeholder": "Enter Slab Name"
    },
    domProps: {
      "value": (_vm.slabName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.slabName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('slabName')),
      expression: "errors.has('slabName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter Slab Name.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Slab Description")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slabDescription),
      expression: "slabDescription"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "slabDescription",
      "id": "slabDescription",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.slabDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.slabDescription = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Slab Type"), _c('span', {
    staticClass: "required"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slabType),
      expression: "slabType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Weight",
      "value": "1",
      "name": "slabType"
    },
    domProps: {
      "checked": _vm._q(_vm.slabType, "1")
    },
    on: {
      "click": _vm.ShowSlabTypeInput,
      "change": _vm.resetSlabData,
      "__c": function($event) {
        _vm.slabType = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Weight"
    }
  }, [_vm._v("Weight (kg)")]), _vm._v("     \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slabType),
      expression: "slabType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "InvoiceAmount",
      "value": "2",
      "name": "slabType"
    },
    domProps: {
      "checked": _vm._q(_vm.slabType, "2")
    },
    on: {
      "click": _vm.ShowSlabTypeInput,
      "change": _vm.resetSlabData,
      "__c": function($event) {
        _vm.slabType = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "InvoiceAmount"
    }
  }, [_vm._v("Invoice Amount (INR)")]), _vm._v("     \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slabType),
      expression: "slabType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Distance",
      "value": "3",
      "name": "slabType"
    },
    domProps: {
      "checked": _vm._q(_vm.slabType, "3")
    },
    on: {
      "click": _vm.ShowSlabTypeInput,
      "change": _vm.resetSlabData,
      "__c": function($event) {
        _vm.slabType = "3"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Distance"
    }
  }, [_vm._v("Distance (km)")]), _vm._v("     \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slabType),
      expression: "slabType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Quantity",
      "value": "4",
      "name": "slabType"
    },
    domProps: {
      "checked": _vm._q(_vm.slabType, "4")
    },
    on: {
      "click": _vm.ShowSlabTypeInput,
      "change": _vm.resetSlabData,
      "__c": function($event) {
        _vm.slabType = "4"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Quantity (Number of Boxes)")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('slabType')),
      expression: "errors.has('slabType')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select Slab Type.")])], 1)]), _vm._v(" "), (_vm.ShowWeightType == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Weight Type"), _c('span', {
    staticClass: "required"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WeightType),
      expression: "WeightType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('WeightType')
    },
    attrs: {
      "type": "radio",
      "id": "Billable",
      "value": "1",
      "name": "WeightType"
    },
    domProps: {
      "checked": _vm._q(_vm.WeightType, "1")
    },
    on: {
      "change": _vm.resetSlabData,
      "__c": function($event) {
        _vm.WeightType = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Billable"
    }
  }, [_vm._v("Billable Weight")]), _vm._v("     \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WeightType),
      expression: "WeightType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('WeightType')
    },
    attrs: {
      "type": "radio",
      "id": "Physical",
      "value": "2",
      "name": "WeightType"
    },
    domProps: {
      "checked": _vm._q(_vm.WeightType, "2")
    },
    on: {
      "change": _vm.resetSlabData,
      "__c": function($event) {
        _vm.WeightType = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Physical"
    }
  }, [_vm._v("Physical Weight")]), _vm._v("     \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WeightType),
      expression: "WeightType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('WeightType')
    },
    attrs: {
      "type": "radio",
      "id": "Volumetric",
      "value": "3",
      "name": "WeightType"
    },
    domProps: {
      "checked": _vm._q(_vm.WeightType, "3")
    },
    on: {
      "change": _vm.resetSlabData,
      "__c": function($event) {
        _vm.WeightType = "3"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Volumetric"
    }
  }, [_vm._v("Volumetric Weight")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('WeightType')),
      expression: "errors.has('WeightType')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select Weight Type.")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.slabType != '') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Define Slab Breaks"), _c('span', {
    staticClass: "required"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "80px"
    }
  }, [_c('b', [_vm._v("Slab Break Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Break Lower Limit Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Break Lower limit value")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Break Higher Limit Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Break Higher Limit Value")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.slabsData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.lowerlimit[index]),
        expression: "form.lowerlimit[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has(("lowerLimit" + index))
      },
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "name": _vm.setname(index, 'lowerLimit'),
        "id": _vm.setname(index, 'lowerLimit'),
        "disabled": true
      },
      on: {
        "select": function($event) {
          _vm.setLowerLimit($event, index)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form.lowerlimit, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Limit Type")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "gt"
      }
    }, [_vm._v("> (greater than)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "gte"
      }
    }, [_vm._v(">= (greater than or equal to)")])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (index == 0 ? _vm.form.lowerlimitvalue[index] : _vm.form.higherlimitvalue[index - 1]),
        expression: "index == 0?form.lowerlimitvalue[index]:form.higherlimitvalue[index-1]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          numeric: true
        }),
        expression: "{required: true, numeric:true}"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has(("lowerValue" + index))
      },
      attrs: {
        "type": "number",
        "min": "0",
        "id": _vm.setname(index, 'lowerValue'),
        "name": _vm.setname(index, 'lowerValue'),
        "maxlength": 11,
        "disabled": true
      },
      domProps: {
        "value": (index == 0 ? _vm.form.lowerlimitvalue[index] : _vm.form.higherlimitvalue[index - 1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(index == 0 ? _vm.form.lowerlimitvalue[index] : _vm.form.higherlimitvalue, index - 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.higherlimit[index]),
        expression: "form.higherlimit[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has(("higherLimit" + index))
      },
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "name": _vm.setname(index, 'higherLimit'),
        "id": _vm.setname(index, 'higherLimit')
      },
      on: {
        "select": function($event) {
          _vm.setHigherimit($event, index)
        },
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form.higherlimit, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.removeError(index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "value": ""
      }
    }, [_vm._v("Limit Type")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "lt"
      }
    }, [_vm._v("< (less than)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "lte"
      }
    }, [_vm._v("<= (less than or equal to)")])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.higherlimitvalue[index]),
        expression: "form.higherlimitvalue[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          numeric: true
        }),
        expression: "{required: true, numeric:true}"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has(("higherValue" + index))
      },
      attrs: {
        "type": "number",
        "min": "0",
        "id": _vm.setname(index, 'higherValue'),
        "name": _vm.setname(index, 'higherValue'),
        "maxlength": 11
      },
      domProps: {
        "value": (_vm.form.higherlimitvalue[index])
      },
      on: {
        "change": function($event) {
          _vm.removeError(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.higherlimitvalue, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [((index) < _vm.slabsData.length && (index != 0)) ? _c('i', {
      staticClass: "fa fa-trash fa-2x",
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.deleteRow(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), ((index + 1) == _vm.slabsData.length) ? _c('i', {
      staticClass: "fa fa-plus-circle fa-2x",
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addNewRow(index)
        }
      }
    }) : _vm._e()])])
  }))])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aade7770","hasScoped":true}!./src/modules/masterdata/views/Slabs/createSlab/createSlab.component.html
// module id = 819
// module chunks = 3